import axios from '@/libs/axios'

export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    fetchPaymentLink(context, { paymentGateway, idRecord }) {
      return new Promise((resolve, reject) => {
        axios.post('payments/stripe/checkout/initiate/', {
          booking: idRecord,
          merchant: paymentGateway,
        }).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    apiCallToGeneratePaymentIntent(context, { paymentGateway, idRecord }) {
      return new Promise((resolve, reject) => {
        axios.post('payments/stripe/payment_intent/initiate/', {
          booking: idRecord,
          merchant: paymentGateway,
        }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  },
}
